import { render, staticRenderFns } from "./DispositionModal.vue?vue&type=template&id=284c9260&"
import script from "./DispositionModal.vue?vue&type=script&lang=js&"
export * from "./DispositionModal.vue?vue&type=script&lang=js&"
import style0 from "./DispositionModal.vue?vue&type=style&index=0&id=284c9260&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports